export default __webpack_public_path__ + "static/media/icone-g00gle-ads.09629770.svg";